import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'components/Icon';
import {FormattedMessage} from 'react-intl';
import {FeatureEnabled, FEATURE_SWITCHES} from 'components/FeatureSwitch';
import AssignPowerUpModal from 'components/AssignPowerUpModal';
import {selectPowerUpAssignment} from 'state/stack/stack/stackSelectors';
import {connect} from 'react-redux';
import DisplayName from 'components/DisplayName';
import './SampleDataBanner.css';

const PoweredSampleDataBanner = ({powerUpAssignment}) => (
  <div className="SampleDataBanner">
    <div>
      <Icon className="SampleDataBanner__Icon" icon={Icon.OPTIONS.CHECK} />
    </div>
    <div className="SampleDataBanner__Text">
      <div className="SampleDataBanner__Title">
        <FormattedMessage
          id="SampleDataBanner__Assigned"
          description="Message indicating who was assigned to power up a page"
          defaultMessage="Assignment sent to {assignee}"
          values={{
            assignee: (
              <DisplayName
                className="SampleDataBanner__Assignee"
                userId={powerUpAssignment}
              />
            ),
          }}
        />
      </div>
    </div>
  </div>
);

const UnpoweredSampleDataBanner = ({pageId, onClick}) => (
  <div className="SampleDataBanner" onClick={onClick}>
    <div>
      <Icon className="SampleDataBanner__Icon" icon={Icon.OPTIONS.CONNECTOR} />
    </div>
    <div className="SampleDataBanner__Text">
      <div className="SampleDataBanner__Title">
        <FormattedMessage
          id="SampleDataBanner__Title"
          description="Title for banner indicating a Card is showing sample data"
          defaultMessage="Example data"
        />
      </div>
      <div className="SampleDataBanner__Instructions">
        {pageId ? (
          <FormattedMessage
            id="SampleDataBanner__Instructions"
            description="Instructions for how to connect a Card with sample data"
            defaultMessage="Tap to connect your data"
          />
        ) : null}
      </div>
    </div>
  </div>
);

class SampleDataBanner extends React.Component {
  constructor() {
    super(...arguments);
    this.handleClick = this.handleClick.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.state = {
      isModalOpen: false,
    };
  }

  handleClick(e) {
    e.stopPropagation();
    this.setState({isModalOpen: true});
    this.props.onClick();
  }

  handleRequestClose() {
    this.setState({isModalOpen: false});
  }

  render() {
    const {pageId, powerUpAssignment} = this.props;
    return (
      <FeatureEnabled feature={FEATURE_SWITCHES.ROLE_BASED_DASHBOARDS}>
        <div>
          {powerUpAssignment ? (
            <PoweredSampleDataBanner powerUpAssignment={powerUpAssignment} />
          ) : (
            <UnpoweredSampleDataBanner
              pageId={pageId}
              onClick={this.handleClick}
            />
          )}
          <AssignPowerUpModal
            pageId={this.props.pageId}
            isOpen={this.state.isModalOpen}
            onRequestClose={this.handleRequestClose}
          />
        </div>
      </FeatureEnabled>
    );
  }
}

SampleDataBanner.propTypes = {
  pageId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

SampleDataBanner.defaultProps = {
  onClick: () => {},
};

export default connect((state, {pageId}) => ({
  powerUpAssignment: selectPowerUpAssignment(state, pageId),
}))(SampleDataBanner);
